export class HideAndShowHelper {
  static isScrollable(el: Element, index?: number): boolean {
    const hideAndShowWrapper = ".hideAndShowWrapper";
    let hideAndShow: HTMLDivElement | null = null;

    if (index == null) {
      hideAndShow = el.querySelector<HTMLDivElement>(hideAndShowWrapper);
    } else {
      const hideAndShows = el.querySelectorAll<HTMLDivElement>(hideAndShowWrapper);
      if (index < hideAndShows.length) {
        hideAndShow = hideAndShows[index];
      }
    }

    return hideAndShow !== null && hideAndShow.scrollWidth > hideAndShow.clientWidth;
  }
}
